import { render } from "./ReferenceProfilePage.vue?vue&type=template&id=ee7796be&scoped=true"
import script from "./ReferenceProfilePage.vue?vue&type=script&lang=js"
export * from "./ReferenceProfilePage.vue?vue&type=script&lang=js"

import "./ReferenceProfilePage.vue?vue&type=style&index=0&id=ee7796be&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee7796be"]])

export default __exports__